module.exports = __webpack_public_path__ + "img/tongjiang.1092af17.png";